import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=4749ba64&scoped=true&"
import script from "./Notes.vue?vue&type=script&lang=js&"
export * from "./Notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749ba64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4749ba64')) {
      api.createRecord('4749ba64', component.options)
    } else {
      api.reload('4749ba64', component.options)
    }
    module.hot.accept("./Notes.vue?vue&type=template&id=4749ba64&scoped=true&", function () {
      api.rerender('4749ba64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/LockerRoom/SubPages/Includes/Notes.vue"
export default component.exports